//------------------Folio por servicio dependencia---------------------------------//
// Acción combo servicio informes FolioPorServicioDependencia
export const COMBO_SERVICIO_INFORME_SUCCESS = 'COMBO_SERVICIO_INFORME_SUCCESS';
export const COMBO_SERVICIO_INFORME_FAIL = 'COMBO_SERVICIO_INFORME_FAIL';
export const COMBO_SERVICIO_INFORME_REQUEST = 'COMBO_SERVICIO_INFORME_REQUEST';

// Acción combo servicio informes Cuenta Fechas
export const COMBO_CUENTA_INFORME_SUCCESS = 'COMBO_CUENTA_INFORME_SUCCESS';
export const COMBO_CUENTA_INFORME_FAIL = 'COMBO_CUENTA_INFORME_FAIL';
export const COMBO_CUENTA_INFORME_REQUEST = 'COMBO_CUENTA_INFORME_REQUEST';

// Acción registro traslado multiple
export const POST_FORMULARIO_TRASLADO_SUCCESS = 'POST_FORMULARIO_TRASLADO_SUCCESS';
export const POST_FORMULARIO_TRASLADO_FAIL = 'POST_FORMULARIO_TRASLADO_FAIL';
export const POST_FORMULARIO_TRASLADO_REQUEST = 'POST_FORMULARIO_TRASLADO_REQUEST';

//------------------Cuenta-Fechas---------------------------------//
// Acción lista cuenta fechas
export const LISTA_CUENTA_FECHAS_SUCCESS = 'LISTA_CUENTA_FECHAS_SUCCESS';
export const LISTA_CUENTA_FECHAS_FAIL = 'LISTA_CUENTA_FECHAS_FAIL';
export const LISTA_CUENTA_FECHAS_REQUEST = 'LISTA_CUENTA_FECHAS_REQUEST';

// Acción lista servicio dependencia informes
export const LISTA_SERVICIO_DEPENDENCIA_SUCCESS = 'LISTA_SERVICIO_DEPENDENCIA_SUCCESS';
export const LISTA_SERVICIO_DEPENDENCIA_FAIL = 'LISTA_SERVICIO_DEPENDENCIA_FAIL';
export const LISTA_SERVICIO_DEPENDENCIA_REQUEST = 'LISTA_SERVICIO_DEPENDENCIA_REQUEST';

//------------------Calcular Drepreciación---------------------------------//
// Acción lista activos fijo de modulo calcular Depreciacion
export const LISTA_ACTIVOS_FIJOS_INFORME_SUCCESS = 'LISTA_ACTIVOS_FIJOS_INFORME_SUCCESS';
export const LISTA_ACTIVOS_FIJOS_INFORME_FAIL = 'LISTA_ACTIVOS_FIJOS_INFORME_FAIL';
export const LISTA_ACTIVOS_FIJOS_INFORME_REQUEST = 'LISTA_ACTIVOS_FIJOS_INFORME_REQUEST';

export const LISTA_ACTIVOS_FIJOS_INFORME_POR_CUENTAS_REQUEST = "LISTA_ACTIVOS_FIJOS_INFORME_POR_CUENTAS_REQUEST";
export const LISTA_ACTIVOS_FIJOS_INFORME_POR_CUENTAS_SUCCESS = "LISTA_ACTIVOS_FIJOS_INFORME_POR_CUENTAS_SUCCESS";
export const LISTA_ACTIVOS_FIJOS_INFORME_POR_CUENTAS_FAIL = "LISTA_ACTIVOS_FIJOS_INFORME_POR_CUENTAS_FAIL";

// Acción lista activos fijo calculados
export const LISTA_ACTIVOS_CALCULADOS_SUCCESS = 'LISTA_ACTIVOS_CALCULADOS_SUCCESS';
export const LISTA_ACTIVOS_CALCULADOS_FAIL = 'LISTA_ACTIVOS_CALCULADOS_FAIL';
export const LISTA_ACTIVOS_CALCULADOS_REQUEST = 'LISTA_ACTIVOS_CALCULADOS_REQUEST';

export const LISTA_ACTIVOS_NO_CALCULADOS_SUCCESS = 'LISTA_ACTIVOS_NO_CALCULADOS_SUCCESS';
export const LISTA_ACTIVOS_NO_CALCULADOS_FAIL = 'LISTA_ACTIVOS_NO_CALCULADOS_FAIL';
export const LISTA_ACTIVOS_NO_CALCULADOS_REQUEST = 'LISTA_ACTIVOS_NO_CALCULADOS_REQUEST';

// Acción lista activos fijo calculados por cuentas
export const LISTA_ACTIVOS_CALCULADOS_POR_CUENTAS_REQUEST = 'LISTA_ACTIVOS_CALCULADOS_POR_CUENTAS_REQUEST';
export const LISTA_ACTIVOS_CALCULADOS_POR_CUENTAS_SUCCESS = 'LISTA_ACTIVOS_CALCULADOS_POR_CUENTAS_SUCCESS';
export const LISTA_ACTIVOS_CALCULADOS_POR_CUENTAS_FAIL = 'LISTA_ACTIVOS_CALCULADOS_POR_CUENTAS_FAIL';

export const LISTA_ACTIVOS_NO_CALCULADOS_POR_CUENTAS_REQUEST = 'LISTA_ACTIVOS_NO_CALCULADOS_POR_CUENTAS_REQUEST';
export const LISTA_ACTIVOS_NO_CALCULADOS_POR_CUENTAS_SUCCESS = 'LISTA_ACTIVOS_NO_CALCULADOS_POR_CUENTAS_SUCCESS';
export const LISTA_ACTIVOS_NO_CALCULADOS_POR_CUENTAS_FAIL = 'LISTA_ACTIVOS_NO_CALCULADOS_POR_CUENTAS_FAIL';
//------------------Fin Calcular Drepreciación---------------------------------//

//------------------Consulta Inveatrio Especies---------------------------------//
export const LISTA_CONSULTA_INVENTARIO_ESPECIES_SUCCESS = 'LISTA_CONSULTA_INVENTARIO_ESPECIES_SUCCESS';
export const LISTA_CONSULTA_INVENTARIO_ESPECIES_FAIL = 'LISTA_CONSULTA_INVENTARIO_ESPECIES_FAIL';
export const LISTA_CONSULTA_INVENTARIO_ESPECIES_REQUEST = 'LISTA_CONSULTA_INVENTARIO_ESPECIES_REQUEST';
//------------------fin -Consulta Inveatrio Especies---------------------------------//

